<template>
  <v-container
    container--fluid
    v-if="context"
    :class="{ 'sidebar-open': !!sidebar, 'resource-open': resourceViewer.show }"
  >
    <outline :show="sidebar == 'outline'" @close="sidebar = false"></outline>
    <research-panel @close="sidebar = false" :show="sidebar == 'research'"></research-panel>
    <side-bar
      @toggleSidebar="sidebar == $event ? (sidebar = false) : (sidebar = $event)"
      :show="sidebar"
    ></side-bar>
    <v-layout
      class="main-content-wrapper white"
      column
      :style="{
        left:
          sidebar && $vuetify.breakpoint.smAndUp
            ? '380px !important'
            : $vuetify.breakpoint.smAndUp
            ? '60px'
            : '50px',
        right: resourceViewer.show ? resourceViewer.width + '%' : 0
      }"
    >
      <v-flex>
        <context-header></context-header>
        <v-breadcrumbs :items="breadCrumbItems" class="py-2"></v-breadcrumbs>
      </v-flex>
      <v-flex xs12 style="position: relative;">
        <v-layout style="position: absolute; top: 0; left: 0px; right: 0; bottom: 0;">
          <!-- <v-flex
            shrink
            ref="questionWrapper"
            :class="{
              'pr-0': true,
              'question-wrapper': true,
              mobile: $vuetify.breakpoint.xsOnly,
              showMobile: showQuestionList
            }"
          >
          </v-flex> -->
          <v-flex
            id="notepage-container"
            xs="12"
            :style="
              `overflow-y: auto;
              overflow-x: hidden;
              padding-bottom: 200px;
              padding-top: ${$vuetify.breakpoint.smAndUp ? '0px;' : '0px'}`
            "
          >
            <template v-if="!loadingPages">
              <content-section></content-section>
            </template>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <context-resource-viewer v-if="resourceViewer.show"></context-resource-viewer>
  </v-container>
</template>

<script>
import ContextHeader from './components/ContextHeader';
import Outline from './components/Outline/';
import ContentSection from './components/ContentSection';
import SideBar from './components/SideBar';
import ResearchPanel from './components/ResearchPanel';
import ResourceViewerModal from '@/components/ResourceViewer/ResourceViewerModal';
import ContextResourceViewer from './components/ContextResourceViewer';

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  name: 'Context',
  components: {
    ContextHeader,
    ResourceViewerModal,
    Outline,
    ContentSection,
    SideBar,
    ResearchPanel,
    ContextResourceViewer
  },
  data() {
    return {
      contextState: 'Try libreoffice to see if it works in a cloud function.',
      loadingPages: true,
      sidebar: 'outline'
    };
  },
  props: ['contextId', 'page'],
  created() {
    this.subscribeToContext({ id: this.contextId });
    this.subscribeToContextPages({ contextId: this.contextId }).finally(
      () => (this.loadingPages = false)
    );
    this.subscribeToContextResources({ contextId: this.contextId });
    if (this.$route.params.page) {
      this.setSelectedPageId({ page: this.$route.params.page });
    } else {
      this.setSelectedPageId(null);
    }
  },
  destroyed() {
    this.unsubscribeToContext();
    this.unsubscribeToContextPages();
  },
  watch: {
    contextId: function(n) {
      this.setSelectedPageId(null);
      this.unsubscribeToContext();
      this.unsubscribeToContextPages();
      this.unsubscribeToContextResources();
      this.subscribeToContext({ id: n });
      this.subscribeToContextResources({ contextId: n });
      this.subscribeToContextPages({ contextId: n });
      this.setResourceViewer({ show: false, resourceId: null });
    },
    title: function(n) {
      if (n) {
        document.title = this.title + ' - Context';
      }
    },
    page: function(n, o) {
      console.log(this.selectedPageId);
      if (this.selectedPageId != n) {
        console.log('set selected page id');
        this.setSelectedPageId({ page: n });
      }
    }
  },
  computed: {
    ...mapGetters('context', ['context']),
    ...mapState('pages', ['pages']),
    ...mapState('views/context', [
      'showResourcePanel',
      'showQuestionList',
      'selectedPageId',
      'resourceViewer'
    ]),
    title() {
      return this.context ? this.context.text : false;
    },
    breadCrumbItems() {
      if (!this.context) {
        return [];
      }
      //   quick truncate function
      function truncate(text, size) {
        return text.length > size + 3 ? text.slice(0, size) + '...' : text;
      }

      const pageId = this.$route.params.page;
      const crumbs = [
        {
          text: this.context.text,
          disabled: !pageId,
          to: { name: this.$route.name, params: { ...this.$route.params, page: false } }
        }
      ];

      if (pageId) {
        if (pageId == 'resources') {
          crumbs.push({
            text: 'Research',
            disabled: true,
            to: { name: this.$route.name, params: { ...this.$route.params, page: 'resources' } }
          });
        }
        if (pageId.split('-')[0] == 'section') {
          crumbs.push({
            text: this.context.sections[pageId.split('-')[1]].text,
            disabled: true,
            to: { name: this.$route.name, params: { ...this.$route.params, page: false } }
          });
        } else {
          const pageData = this.pages[pageId];
          if (!pageData) return crumbs;
          //const section = this.context.sections[pageData.section] || { text: 'section', id: 1 };
          // crumbs.push({
          //   text: truncate(section.text, 20),
          //   disabled: false,
          //   to: {
          //     name: this.$route.name,
          //     params: { ...this.$route.params, page: `section-${section.id}` }
          //   }
          // });
          const crumbParams = this.$route.query.crumb ? this.$route.query.crumb.split('-') : [];
          crumbParams.forEach((c, i) => {
            const crumbPage = this.pages[c];
            if (this.context.basePage != c && crumbPage) {
              const crumLink = crumbParams.slice(0, i);
              crumbs.push({
                text: truncate(crumbPage.title, 20),
                disabled: false,
                to: {
                  name: this.$route.name,
                  params: { ...this.$route.params, page: c },
                  query: { crumb: crumLink.join('-') }
                }
              });
            }
          });
          if (this.context.basePage != pageId) {
            crumbs.push({
              text: truncate(pageData.title, 20),
              disabled: true,
              to: { name: this.$route.name, params: { ...this.$route.params, page: false } }
            });
          }
        }
      }
      return crumbs;
    }
  },
  methods: {
    ...mapActions('context', ['subscribeToContext', 'unsubscribeToContext', 'checkContextAuthor']),
    ...mapActions('pages', ['subscribeToContextPages', 'unsubscribeToContextPages']),
    ...mapActions('resources', ['subscribeToContextResources', 'unsubscribeToContextResources']),
    ...mapMutations('views/context', ['setSelectedPageId', 'setResourceViewer'])
  }
};
</script>

<style scoped>
.main-content-wrapper {
  position: absolute;
  top: 0px;
  left: 0;
  right: 0px;
  bottom: 0;
  transition: 0.2s ease right;
}

/* .resource-open .main-content-wrapper {
  right: 50%;
} */

.question-wrapper {
  border-right: 0px solid #d0d0d0;
  width: 350px;
  min-width: 350px;
  overflow-y: auto;
}

.question-wrapper.mobile {
  position: fixed;
  background: #f5f5f5;
  z-index: 4;
  top: 50px;
  bottom: 0;
  right: 0px;
  left: 0;
  transform: translateX(-100%);
  width: 100%;
  transition-duration: 0.2s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  will-change: transform;
  transition-property: transform, width, -webkit-transform;
}

.question-wrapper.mobile.showMobile {
  transform: translateX(0%);
}
</style>
